// extracted by mini-css-extract-plugin
module.exports = {"inputs":"inputs___28WVL","hours":"hours___2sJAd","delimiter":"delimiter___21apG","mins":"mins___nlTYI","ampm":"ampm___YCmcu"};